import { createContext } from 'react';
import { CALENDAR_VIEW } from '@/types';

export type CalendarContextType = {
  selectedCalendar: string;
  setSelectedCalendar: (calendarId: string) => void;

  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  currentView: CALENDAR_VIEW;
  setCurrentView: (view: CALENDAR_VIEW) => void;
};

export const CalendarContext = createContext<CalendarContextType | undefined>(undefined);
